import {Breakpoint, Dialog as MuiDialog} from '@mui/material';
import React from "react";

interface DialogProps {
  isOpen: boolean;
  onBackdropClick?: () => void;
  size?: Breakpoint;
  children: React.ReactNode;
}

export const Dialog = ({
  isOpen,
  onBackdropClick = () => null,
  size="sm",
  children,
}: DialogProps) => (
  <MuiDialog
    open={isOpen}
    onClose={onBackdropClick}
    maxWidth={size}
    PaperProps={{
      sx: { borderRadius: 6 },
    }}
  >
    {children}
  </MuiDialog>
)
